<template>
   <div class="container d-flex">
      <a class="hyper-section" name="main1"></a>
<section> <h1> Tjänster</h1>   
<p> Nedan listar vi några av de vanligaste uppdragsområdena vi arbetar med men vi välkomnar lika gärna projekt som är unika.

Med vår kunskap och erfarenhet samt villighet att åta oss utmaningar kan vi garantera att vi kommer att göra vårt allra yttersta för att just ert projekt ska bli så bra som möjligt.
<ul> 
   <li>  Husmålningar </li>
   <li>  Spackling/målning </li>
   <li>  Tapetsering </li>
   <li>  Golvläggning </li>
   <li>  Kakel/klinker</li>
   <li>  Fasadbyten </li>
   <li>  Bygg altan </li>
   <li>  Renoveringar </li> 


   </ul>

.</p>	
</section>
  </div>
  
</template>

<script>
export default {

}
</script>

<style>

</style>